<mat-dialog-content>
  <span
    class="material-icons close-icon"
    (click)="close()"
  >
    clear
  </span>
  <p class="title" translate>ORDER_NUMBER.FREE_PORTING_MODAL.TITLE</p>
  <p class="description" translate>ORDER_NUMBER.FREE_PORTING_MODAL.DESCRIPTION</p>

  <div class="countries">
    <div *ngFor="let country of getCountries()" class="country-row">
      <span [ngClass]="['flag-icon-' + country.alpha2.toLowerCase()]" class="flag-icon flag"></span>
      <span class="country-name">{{country.name | translate}}</span>
    </div>
  </div>
  <p class="footer">
    <span translate>ORDER_NUMBER.FREE_PORTING_MODAL.REQUEST</span>
    <span
      class="support-link"
      (click)="contactSupport()"
      translate
    >
      ORDER_NUMBER.FREE_PORTING_MODAL.START_CHAT
    </span>
  </p>
</mat-dialog-content>
